function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", {
  id: "defs63"
});

var _ref3 = /*#__PURE__*/React.createElement("style", {
  id: "style2",
  type: "text/css"
}, "\n\t.st0{fill:#E30613;}\n\t.st1{fill:#BDBCBC;}\n\t.st2{fill:#003758;}\n\t.st3{opacity:0.11;}\n\t.st4{opacity:0.21;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#97C3DB;}\n\t.st7{fill:#1384B5;}\n\t.st8{fill:#0F9CD8;}\n\t.st9{fill:#AF1830;}\n");

function SvgDigitalLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 333.18185 38.172331",
    y: "0px",
    x: "0px",
    id: "Ebene_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.00268096,5.3214009e-6)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e30613",
      strokeWidth: 0.57763153
    },
    id: "path4",
    d: "m 30.890602,35.64564 -19.50084,-1.91196 c -0.635395,-0.06354 -1.0975,-0.629619 -1.039737,-1.265013 L 13.457683,1.0397345 c 0.06354,-0.62961836 0.629618,-1.0974999 1.265013,-1.03396043 l 19.50084,1.91196043 c 0.635395,0.063539 1.0975,0.6296183 1.039737,1.265013 L 32.155615,34.61168 c -0.06931,0.629618 -0.635394,1.0975 -1.265013,1.03396 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97c3db",
      strokeWidth: 0.57763153
    },
    id: "path6",
    d: "m 30.162787,30.92639 -18.26471,6.69475 c -0.618065,0.225276 -1.322776,-0.10975 -1.565381,-0.745145 L 0.07973606,9.894826 C -0.16286918,9.2594313 0.14905185,8.5547209 0.7671176,8.3236682 L 19.031827,1.634695 c 0.618066,-0.2252763 1.322776,0.10975 1.565381,0.7451447 l 10.25296,26.9811693 c 0.242605,0.635395 -0.06354,1.340105 -0.687381,1.565381 z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.726404,1.6816013)",
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e30613"
    },
    id: "path8",
    d: "m 123.1,29 c 4.12,0.07 5.8,0.07 7.96,0.05 3.72,-0.05 5.09,-0.26 7.17,-1.98 1.38,-1.11 2.08,-3.07 2.08,-4.84 0,-0.93 -0.09,-3.91 -3.73,-5.17 1.83,-1.02 2.63,-2.76 2.63,-4.48 0,-1.29 -0.34,-2.64 -1.35,-3.67 -1.65,-1.8 -3.24,-2.19 -7.05,-2.23 -2.55,-0.02 -3.89,-0.02 -7.71,0.07 z m 5.56,-17.25 h 2.58 c 0.89,0 2.44,0 2.44,1.68 0,1.77 -1.65,1.77 -2.44,1.77 h -2.58 z m 0,8.2 h 3.25 c 0.92,0 2.87,0 2.87,1.92 0,2.13 -2.14,2.13 -2.87,2.13 l -3.25,0.01 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e30613"
    },
    id: "path10",
    d: "m 118.37,7.37 c -1.83,-0.56 -4.26,-0.98 -6.59,-0.98 -8.19,0 -13.25,4.85 -13.25,12.02 0,6.61 4.03,10.84 11.59,10.84 3.06,0 5.93,-0.59 8.09,-1.54 V 16.8 h -6.19 v 6.71 c -0.33,0.1 -0.8,0.16 -1.26,0.16 -3.83,0 -5.49,-2.26 -5.49,-5.7 0,-3.57 2.13,-6.09 6.22,-6.09 2.23,0 4.23,0.42 5.96,1.08 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e30613"
    },
    id: "path12",
    d: "m 89.05,17.68 c 0,-3.85 -1.45,-5.84 -4.45,-5.84 -2.19,0 -4.42,1.63 -4.42,5.77 0,3.75 1.25,6.04 4.28,6.04 1.97,0 4.59,-1.31 4.59,-5.97 m 6.71,-0.64 c 0,7.15 -5.09,12.1 -11.57,12.1 -7.16,0 -10.66,-4.16 -10.66,-11.11 0,-6.46 4.32,-10.9 9.92,-11.62 l 1.19,4.3 c 1.02,-0.45 2.16,-0.7 3.37,-0.7 4.28,-0.01 7.74,3.14 7.75,7.03 0,-0.99 -0.08,-1.9 -0.21,-2.74 0.14,0.83 0.21,1.74 0.21,2.74",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bdbcbc"
    },
    id: "path14",
    d: "m 84.62,10.73 c 1.02,-0.45 2.16,-0.7 3.37,-0.7 4.28,0 7.54,2.95 7.77,7.08 0.13,-3.15 -0.81,-5.75 -2.17,-7.43 -2.17,-2.73 -5.78,-4.53 -9.86,-4.53 -0.22,0 -0.43,0.01 -0.65,0.02 z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003758"
    },
    id: "path16",
    d: "m 253.96,10.43 c 0,-0.21 -0.36,-0.78 -0.68,-1.32 -1.07,-1.67 -2.67,-2.88 -5.63,-2.88 h -2.35 c -4.06,0 -6.62,2.6 -6.62,6.3 v 10.54 c 0,3.7 2.56,6.3 6.62,6.3 h 1.74 c 4.02,0 6.62,-2.6 6.62,-6.3 v -5.41 c 0,-0.25 -0.11,-0.36 -0.36,-0.36 h -7.44 c -0.25,0 -0.36,0.11 -0.36,0.36 v 3.03 c 0,0.25 0.11,0.36 0.36,0.36 h 3.35 c 0.25,0 0.36,0.11 0.36,0.36 v 1.67 c 0,1.42 -1.1,2.56 -2.53,2.56 h -1.74 c -1.39,0 -2.56,-1.18 -2.56,-2.56 V 12.53 c 0,-1.39 1.18,-2.56 2.56,-2.56 h 2.35 c 0.96,0 1.89,0.57 2.53,2.1 0.07,0.18 0.18,0.25 0.28,0.25 0.14,0 0.28,-0.11 0.43,-0.18 l 2.85,-1.46 c 0.15,-0.07 0.22,-0.15 0.22,-0.25 m -24.21,10.32 c 0,0.18 -0.14,0.32 -0.39,0.32 h -2.6 c -0.25,0 -0.39,-0.14 -0.39,-0.32 0,-0.14 0.11,-0.46 0.18,-0.71 l 1.07,-4.13 c 0.07,-0.28 0.36,-1.67 0.43,-1.96 h 0.11 c 0.07,0.28 0.32,1.71 0.39,1.96 l 1.03,4.17 c 0.06,0.21 0.17,0.53 0.17,0.67 m 6.62,7.98 c 0,-0.14 -0.11,-0.43 -0.18,-0.64 L 229.71,6.83 c -0.04,-0.18 -0.18,-0.25 -0.36,-0.25 h -2.56 c -0.18,0 -0.32,0.07 -0.36,0.25 l -6.48,21.26 c -0.07,0.28 -0.18,0.5 -0.18,0.64 0,0.18 0.14,0.28 0.39,0.28 h 3.56 c 0.18,0 0.32,-0.07 0.36,-0.25 l 1.07,-3.74 c 0.04,-0.18 0.18,-0.21 0.36,-0.21 h 5.09 c 0.18,0 0.32,0.04 0.36,0.21 l 1.07,3.74 c 0.04,0.18 0.18,0.25 0.36,0.25 h 3.6 c 0.24,0 0.38,-0.1 0.38,-0.28 m -18.48,-0.07 v -3.03 c 0,-0.25 -0.11,-0.36 -0.36,-0.36 h -8.47 c -0.25,0 -0.36,-0.11 -0.36,-0.36 V 6.94 c 0,-0.25 -0.11,-0.36 -0.36,-0.36 h -3.38 c -0.25,0 -0.36,0.11 -0.36,0.36 v 21.72 c 0,0.25 0.11,0.36 0.36,0.36 h 12.57 c 0.26,-0.01 0.36,-0.11 0.36,-0.36 M 196.07,13.2 c 0,1.39 -1.17,2.56 -2.56,2.56 h -3.92 c -0.25,0 -0.36,-0.11 -0.36,-0.36 v -4.74 c 0,-0.25 0.11,-0.36 0.36,-0.36 h 3.92 c 1.39,0 2.56,1.18 2.56,2.56 z m 4.45,15.53 c 0,-0.11 -0.11,-0.32 -0.18,-0.57 l -3.06,-8.9 c -0.11,-0.28 -0.18,-0.46 -0.18,-0.57 0,-0.14 0.04,-0.21 0.14,-0.28 1.35,-0.93 2.88,-3.03 2.88,-4.84 V 13.2 c 0,-4.02 -2.56,-6.62 -6.62,-6.62 h -8.01 c -0.25,0 -0.36,0.11 -0.36,0.36 v 21.72 c 0,0.25 0.11,0.36 0.36,0.36 h 3.38 c 0.25,0 0.36,-0.11 0.36,-0.36 v -8.79 c 0,-0.25 0.11,-0.36 0.36,-0.36 h 3.17 c 0.14,0 0.25,0.07 0.28,0.21 l 3.13,9.04 c 0.04,0.14 0.18,0.25 0.32,0.25 h 3.67 c 0.25,0 0.36,-0.1 0.36,-0.28 m -19.83,-0.07 v -3.03 c 0,-0.25 -0.11,-0.36 -0.36,-0.36 h -8.47 c -0.25,0 -0.36,-0.11 -0.36,-0.36 v -5.06 c 0,-0.25 0.11,-0.36 0.36,-0.36 h 6.94 c 0.25,0 0.36,-0.11 0.36,-0.36 V 16.1 c 0,-0.25 -0.11,-0.36 -0.36,-0.36 h -6.94 c -0.25,0 -0.36,-0.11 -0.36,-0.36 v -4.74 c 0,-0.25 0.11,-0.36 0.36,-0.36 h 8.47 c 0.25,0 0.36,-0.11 0.36,-0.36 V 6.94 c 0,-0.25 -0.11,-0.36 -0.36,-0.36 h -12.57 c -0.25,0 -0.36,0.11 -0.36,0.36 v 21.72 c 0,0.25 0.11,0.36 0.36,0.36 h 12.57 c 0.25,-0.01 0.36,-0.11 0.36,-0.36 M 164.59,6.87 c 0,-0.18 -0.14,-0.28 -0.39,-0.28 h -3.6 c -0.18,0 -0.32,0.07 -0.36,0.25 l -3.52,12.89 c -0.07,0.25 -0.28,1.28 -0.36,1.57 h -0.18 c -0.07,-0.28 -0.28,-1.35 -0.36,-1.64 L 152.3,6.84 c -0.04,-0.18 -0.18,-0.25 -0.36,-0.25 h -3.56 c -0.25,0 -0.39,0.11 -0.39,0.28 0,0.18 0.11,0.43 0.18,0.68 l 6.48,21.22 c 0.04,0.18 0.18,0.25 0.36,0.25 h 2.56 c 0.18,0 0.32,-0.07 0.36,-0.25 l 6.52,-21.36 c 0.04,-0.15 0.14,-0.4 0.14,-0.54",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#878787",
      fillOpacity: 1
    },
    transform: "matrix(1.0911396,0,0,1.0911396,153.3477,-34.068682)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      fillOpacity: 1
    },
    id: "path20",
    d: "m 82.69,59.75 h -6.48 c -0.23,0 -0.33,-0.1 -0.33,-0.33 V 39.08 c 0,-0.23 0.1,-0.33 0.33,-0.33 h 6.48 c 3.54,0 5.84,2.24 5.84,5.78 v 9.38 c 0,3.57 -2.31,5.84 -5.84,5.84 z m 3.6,-15.56 c 0,-1.94 -1.6,-3.54 -3.61,-3.54 h -4.24 c -0.23,0 -0.33,0.1 -0.33,0.33 v 16.53 c 0,0.23 0.1,0.33 0.33,0.33 h 4.24 c 2,0 3.61,-1.57 3.61,-3.57 z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      fillOpacity: 1
    },
    id: "path22",
    d: "m 95.14,59.75 h -1.57 c -0.23,0 -0.33,-0.1 -0.33,-0.33 V 39.08 c 0,-0.23 0.1,-0.33 0.33,-0.33 h 1.57 c 0.23,0 0.33,0.1 0.33,0.33 v 20.33 c 0,0.24 -0.1,0.34 -0.33,0.34 z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      fillOpacity: 1
    },
    id: "path24",
    d: "m 107.06,60.08 h -1.04 c -3.54,0 -5.81,-2.24 -5.81,-5.48 V 43.86 c 0,-3.24 2.27,-5.48 5.81,-5.48 h 1.67 c 2.24,0 3.57,0.73 4.47,1.8 0.33,0.4 0.7,0.9 0.7,1.07 0,0.13 -0.1,0.23 -0.23,0.3 l -1.2,0.6 c -0.13,0.07 -0.27,0.13 -0.37,0.13 -0.1,0 -0.17,-0.03 -0.23,-0.13 -0.8,-1.2 -2.04,-1.84 -3.14,-1.84 h -1.67 c -2,0 -3.54,1.54 -3.54,3.54 V 54.6 c 0,1.94 1.54,3.57 3.54,3.57 h 1.04 c 1.94,0 3.57,-1.64 3.57,-3.57 v -2.67 c 0,-0.23 -0.1,-0.33 -0.33,-0.33 h -3.51 c -0.23,0 -0.33,-0.1 -0.33,-0.33 V 50 c 0,-0.23 0.1,-0.33 0.33,-0.33 h 5.78 c 0.23,0 0.33,0.1 0.33,0.33 v 4.61 c 0,3.24 -2.3,5.47 -5.84,5.47 z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      fillOpacity: 1
    },
    id: "path26",
    d: "m 119.24,59.75 h -1.57 c -0.23,0 -0.33,-0.1 -0.33,-0.33 V 39.08 c 0,-0.23 0.1,-0.33 0.33,-0.33 h 1.57 c 0.23,0 0.33,0.1 0.33,0.33 v 20.33 c 0.01,0.24 -0.09,0.34 -0.33,0.34 z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      fillOpacity: 1
    },
    id: "path28",
    d: "m 134.7,40.65 h -4.04 c -0.23,0 -0.33,0.1 -0.33,0.33 v 18.43 c 0,0.23 -0.1,0.33 -0.33,0.33 h -1.57 c -0.23,0 -0.33,-0.1 -0.33,-0.33 V 40.99 c 0,-0.23 -0.1,-0.33 -0.33,-0.33 h -4.04 c -0.23,0 -0.33,-0.1 -0.33,-0.33 v -1.24 c 0,-0.23 0.1,-0.33 0.33,-0.33 h 10.98 c 0.23,0 0.33,0.1 0.33,0.33 v 1.24 c 0,0.22 -0.1,0.32 -0.34,0.32 z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      fillOpacity: 1
    },
    id: "path30",
    d: "m 149.13,59.75 h -1.7 c -0.17,0 -0.3,-0.07 -0.33,-0.23 l -1.3,-4.61 c -0.03,-0.17 -0.17,-0.2 -0.33,-0.2 h -6.28 c -0.17,0 -0.3,0.03 -0.33,0.2 l -1.3,4.61 c -0.03,0.17 -0.17,0.23 -0.33,0.23 h -1.7 c -0.23,0 -0.37,-0.1 -0.37,-0.27 0,-0.17 0.13,-0.53 0.23,-0.83 l 5.98,-19.66 c 0.03,-0.17 0.17,-0.23 0.33,-0.23 h 1.27 c 0.17,0 0.3,0.07 0.33,0.23 l 5.91,19.46 c 0.17,0.5 0.3,0.9 0.3,1.04 -0.02,0.16 -0.15,0.26 -0.38,0.26 z m -6.35,-15.96 c -0.03,-0.17 -0.3,-1.04 -0.37,-1.3 h -0.13 c -0.07,0.27 -0.3,1.1 -0.37,1.3 l -2.4,8.71 c 0,0.17 0.13,0.3 0.37,0.3 h 4.81 c 0.23,0 0.37,-0.13 0.37,-0.3 z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      fillOpacity: 1
    },
    id: "path32",
    d: "m 164.49,59.75 h -10.95 c -0.23,0 -0.33,-0.1 -0.33,-0.33 V 39.08 c 0,-0.23 0.1,-0.33 0.33,-0.33 h 1.57 c 0.23,0 0.33,0.1 0.33,0.33 v 18.43 c 0,0.23 0.1,0.33 0.33,0.33 h 8.71 c 0.23,0 0.33,0.1 0.33,0.33 v 1.24 c 0.01,0.24 -0.09,0.34 -0.32,0.34 z",
    className: "st2"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      strokeWidth: 0.57763153
    },
    id: "path38",
    d: "m 30.428497,34.888943 -18.588183,2.166118 c -0.629618,0.07509 -1.20725,-0.381237 -1.282342,-1.010855 L 7.4387619,9.2767603 C 7.3636698,8.6471419 7.8199987,8.0695104 8.4496171,7.9944183 L 27.043576,5.8225237 c 0.629619,-0.075092 1.20725,0.3812368 1.282342,1.0108552 l 3.119211,26.7674451 c 0.07509,0.635395 -0.381237,1.213027 -1.016632,1.288119 z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.57763154,0,0,0.57763154,-0.00113235,-2.2490578e-6)",
    id: "g56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#003758"
    },
    id: "polygon40",
    points: "20.18,52.5 23.69,52.89 27.03,27.02 23.51,26.62 ",
    className: "st2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#003758"
    },
    id: "rect42",
    height: 24.5,
    width: 3.8399999,
    className: "st2",
    transform: "matrix(0.9938,-0.1108,0.1108,0.9938,-4.0341,4.7372)",
    y: 26.43,
    x: 38.700001
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#003758"
    },
    id: "rect44",
    height: 19.709999,
    width: 4.1199999,
    className: "st2",
    transform: "matrix(0.9938,-0.1108,0.1108,0.9938,-4.1971,5.3623)",
    y: 30.6,
    x: 44.099998
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#003758"
    },
    id: "rect46",
    height: 31.610001,
    width: 3.3299999,
    className: "st2",
    transform: "matrix(0.9938,-0.1108,0.1108,0.9938,-3.7326,4.1534)",
    y: 19.870001,
    x: 33.849998
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#003758"
    },
    id: "rect48",
    height: 27.07,
    width: 3.55,
    className: "st2",
    transform: "matrix(0.9938,-0.1108,0.1108,0.9938,-4.0634,3.7044)",
    y: 24.889999,
    x: 29.530001
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003758"
    },
    id: "path54",
    d: "m 47.96,8.76 -34.28,3.82 c -1.26,0.14 -2.17,1.28 -2.03,2.54 l 5.45,48.92 c 0.14,1.26 1.28,2.17 2.54,2.03 l 34.28,-3.82 c 1.26,-0.14 2.17,-1.28 2.03,-2.54 L 50.5,10.79 C 50.36,9.53 49.22,8.62 47.96,8.76 Z m 4.84,43.95 c 0.14,1.26 -0.77,2.4 -2.03,2.54 l -29.59,3.3 c -1.26,0.14 -2.4,-0.77 -2.54,-2.03 L 14.27,17.3 c -0.14,-1.26 0.77,-2.4 2.03,-2.54 l 29.59,-3.3 c 1.26,-0.14 2.4,0.77 2.54,2.03 z",
    className: "st2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalLogoSmall);
export default __webpack_public_path__ + "static/media/digital-logo-small.8d0f514c.svg";
export { ForwardRef as ReactComponent };